<div class="menu-item">
  <mf-icon [icon]="menuItem.icon"></mf-icon>
  <div class="menu-text">
    {{ menuItem.label }}
  </div>
</div>
